//
//
//
//
//
//


export default {
  props: {
    content: {
      type: String
    },
    duration: {
      type: [Number, String],
      default: 3
    },
    type: {
      type: String,
      default: 'info'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Message/message.vue